import { Injectable } from '@angular/core'
import { PageResultDto } from '../../dto'
import { HttpService } from '../http.service'
import { ADMIN_API_ENDPOINTS } from '@api/common/api-endpoints'
import { HttpParams } from '@angular/common/http'
import {
  GovernTenantDto,
  CreateGovernTenantDto,
  UpdateGovernTenantDto,
  FindGovernTenantDto,
  SortOrderGovernTenantDto,
  GovernTenantResponseDto
} from '../../dto/governance-admin/tenant.dto'

@Injectable({
  providedIn: 'root'
})
export class GovernTenantApiService {
  constructor(private httpService: HttpService) {}

  async find(findGovernTenantDto: FindGovernTenantDto | HttpParams ) {
    return await this.httpService.get<PageResultDto<GovernTenantDto>>(ADMIN_API_ENDPOINTS.OFFLINE_TENANTS, findGovernTenantDto)
  }

  async findOne(id: string) {
    const endpoint = `${ADMIN_API_ENDPOINTS.OFFLINE_TENANTS}/${id}`;
    return await this.httpService.get<GovernTenantDto>(endpoint);
  }

  async create(createGovernTenantDto: CreateGovernTenantDto) {
    return await this.httpService.post<GovernTenantDto>(ADMIN_API_ENDPOINTS.OFFLINE_TENANTS, createGovernTenantDto)
  }

  async update(id: string, updateGovernTenantDto: UpdateGovernTenantDto) {
    return await this.httpService.put<GovernTenantDto>(`${ADMIN_API_ENDPOINTS.OFFLINE_TENANTS}/${id}`, updateGovernTenantDto)
  }

  async delete(id: string) {
    return await this.httpService.delete<boolean>(`${ADMIN_API_ENDPOINTS.OFFLINE_TENANTS}/${id}`)
  }

  async setAdminEnabled(id: string, enabled: boolean) {
    return await this.httpService.patch<GovernTenantDto>(`${ADMIN_API_ENDPOINTS.OFFLINE_TENANTS}/${id}/admin-enabled`, { enabled })
  }

  async updateSortOrder(sortOrderTenantDto: SortOrderGovernTenantDto) {
    return await this.httpService.patch<GovernTenantDto>(`${ADMIN_API_ENDPOINTS.OFFLINE_TENANTS}/sort-order`, sortOrderTenantDto)
  }

  async whitelistMid(id: string, paywayTenantId: string) {
    return await this.httpService.post<GovernTenantResponseDto>(`${ADMIN_API_ENDPOINTS.OFFLINE_TENANTS}/${id}/whitelist-mid`, { paywayTenantId })
  }

  async exportExcel(findGovernTenantDto: FindGovernTenantDto) {
    return await this.httpService.get<Blob>(`${ADMIN_API_ENDPOINTS.OFFLINE_TENANTS}/export`, findGovernTenantDto)
  }

  async enable(id: string) {
    return await this.httpService.patch<boolean>(`${ADMIN_API_ENDPOINTS.OFFLINE_TENANTS}/${id}/enable`)
  }

  async disable(id: string) {
    return await this.httpService.patch<boolean>(`${ADMIN_API_ENDPOINTS.OFFLINE_TENANTS}/${id}/disable`)
  }
} 